export const IconMicrosoft30: {
  name: 'icon_microsoft_30-c515f31dd091'
} = {
  name: 'icon_microsoft_30-c515f31dd091'
}
